import { ButtonHTMLAttributes, DetailedHTMLProps } from 'react'
import { Button as StyleGuideButton } from './ui/Button'

/**
 * Button component properties extending HTML button attributes
 */
interface ButtonProps extends DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  mode?: 'primary' | 'secondary' | 'danger'
  size?: 'sm' | 'md' | 'lg'
}

/**
 * Button wrapper component that maps to the style guide button
 * @param {ButtonProps} props - Button properties including mode, disabled state, onClick handler, etc.
 * @returns {JSX.Element} Styled button component with neon theme
 */
export function Button(props: ButtonProps) {
  // Map the old Button props to the new style-guide Button props
  return (
    <StyleGuideButton
      mode={props.mode || "primary"}
      size={props.size || "lg"}
      fullWidth={true}
      hoverStyle="fill"
      disabled={props.disabled}
      onClick={props.onClick ? () => props.onClick?.(null as any) : undefined}
      type={props.type as 'button' | 'submit' | 'reset' | undefined}
      className={props.className}
    >
      {props.children}
    </StyleGuideButton>
  )
}
